<template>
  <div>
    <h6 class="magic-link">
      <!-- <span class="magic-link-user">Hello {{ tokenLink }} </span><br /> -->
      <span v-if="!calendar_subscription" class="magic-link-message">Please wait! we are logging you in...</span>
      <span v-else class="magic-link-message">Please wait! we are checking your payment status...</span>
    </h6>
  </div>
</template>

<script>
import service from '../services';
import {global} from '../global.js';
// #2066 — Stripe is removed from cs3. The `loadStripe()` call that used to sit in this
// file's init path injected https://js.stripe.com/v3 and beaconed r./m./q.stripe.com on
// every page load, with no Stripe feature left to serve.
import { mapGetters, mapActions } from "vuex";
import { sanitize } from '../safeHtmlRules.js';   // #2036

export default {
  data() {
    return {
      email: '',
      token: '',
      loading: false,
      credential_err: '',
      languageSelected:'en',
      domainLogo: null,
      clientdata: null,
      login_image: "",
      login_text: "",
      loginType: false,
      language: 'en',
      app_source: false,
      client_id: '',
      calendar_subscription: false,
      employee_id: '',
      successURL: window.location.href.split('#')[0]+"#/stripe-success",
      cancelURL: 'https://cs3.me/confirm2',
      stripe_customer_id: '',
      stripe: null,
    };
  },
  computed: {
    // tokenLink() {
    //   if(this.$route.params.tokenLink) {
    //     return this.$route.params.tokenLink;
    //   }
    //   return null;
    // },
    ...mapGetters({
      queryParamClientId: 'queryParamClientId',
      queryParamAppSource: 'queryParamAppSource',
      userToken: 'userToken',
      userClientID: 'userClientID',
      userRole: 'userRole',
      userID: "userID"
    }),
    deviceDetector() {
        let userAgent = navigator.userAgent.toLowerCase();
        const check =(/(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent) ? "tablet" : /(mobi|ipod|phone|blackberry|opera mini|fennec|minimo|symbian|psp|nintendo ds|archos|skyfire|puffin|blazer|bolt|gobrowser|iris|maemo|semc|teashark|uzard)/.test(userAgent) ? "phone" : "desktop");
        return("desktop" != check ? !0 : !1);
    }
  },
  methods: {
    async loginUser() {
      let params = {
        email: '',
        token: '',
        url: ''
      }
      if(this.email&&this.token) {
        params.email = this.email;
        params.token = this.token;
        params.url = window.location.href.split('#')[0];
        // params.client_id = this.client_id;
        await service.post('auth/magic-link/swapMagicLinkToken', params)
        .then(async (res) => {
          let queryParams = {
            app_source: this.app_source,
            client_id: this.client_id
          }
          queryParams = JSON.stringify(queryParams);
          localStorage.setItem('queryParams', queryParams);
          await this.getIntoApp(res);
          // console.log(res.data)
        }).catch((err) => {
          console.log(err);
          this.$notify.error({
            message: 'Something went wrong! Please contact Support team',
            title: 'Error'
          });
          this.$router.push({
            path: '/login'
          })
        });
      } else {
        this.$notify.error({
          message: 'Something went wrong! Please contact Support team',
          title: 'Error'
        });
        this.$router.push({
            path: '/login'
        })
      }
    },



    async getIntoApp(res) {
        localStorage.removeItem('vuex');
        if (res.data.status_code == 0) {
            this.$Progress.fail();
            this.loading = false;
            this.credential_err = res.data.status_message;
            // console.log(this.credential_err);
        } else {
            let data = res.data.result;
            // console.log('correct',  data);
            this.$store.dispatch('userSession', data);
            this.$store.dispatch('setLoginSuper', false);
            // console.log('***************** ');
            this.$cookies.set("csLogin", data.role.slug, "23h");
            this.$cookies.set("csLogin", data.role.slug, "23h",'/mobile');
            this.credential_err = "";
            this.$Progress.finish();
            $('.wrapper').css('margin-left', '60px');
            /* for support chat box.*/
            let self = this;
            let employeeObjs = data.user.employees.length ? data.user.employees : [];
            let clients = [];
            if(employeeObjs.length) {
              clients = employeeObjs.filter((emp) => {
                return emp.client_employee && emp.client_employee.clients && emp.client_employee.clients.id == this.client_id
              })
              console.log(clients)
            }
            if(clients.length) {
              this.$store.dispatch('setEmployeeId', clients[0].client_employee.employee_id);
              this.employee_id = clients[0].client_employee.employee_id;
            }
            /* END CHAT SUPPORT */

            if (data.role.slug == "client-admin" || data.role.slug == "employee" || data.role.slug == "power-user" || data.role.slug == "power-user-minus" || data.role.slug == "auditor") {
                if(data.user && data.user.employees && data.user.employees.length && data.user.employees[0].client_employee && data.user.employees[0].client_employee.clients){
                    this.$cookies.set("time_zone", data.user.employees[0].client_employee.clients.timezone, "23h");
                    this.$cookies.set("date_format", data.user.employees[0].date_format, "23h");
                    this.$cookies.set("time_format", data.user.employees[0].time_format, "23h");
                    this.$cookies.set("powerSteward", data.user.employees[0].client_employee.clients.power_steward, "23h");
                    var notifyType = (data.user.employees[0].email_notification == 1) ? 'email' : 'sms';

                    this.$store.dispatch('setNotificationType', notifyType);
                    this.$store.dispatch('setClientdata', data.user.employees[0].client_employee.clients);
                }
                let query_params = {};
                if (this.app_source) {
                  query_params.app_source = this.app_source;
                }
                if (this.client_id && this.client_id != '') {
                  query_params.client_id = this.client_id;
                }
                // #1931 — the calendar-subscription branch sent the user into the Nylas/Stripe
                // subscribe flow, whose endpoints are deleted. A magic link carrying
                // `calendar_subscription` now falls through to the normal role routing below.

                if (data.role.slug == "client-admin" || data.role.slug == "power-user" || data.role.slug == "power-user-minus") {
                    this.$store.dispatch('setLastOpenJob', 0);
                    if(data.role.slug == "power-user" || data.role.slug == "power-user-minus"){
                        this.$router.push({
                            path: "/switchClient",
                            query: query_params
                        });
                    }
                    else{
                        this.$router.push({
                            path: "/jobList"
                        });
                    }
                } else {
                    if(document.getElementsByTagName('body')[0].clientWidth < 700)
                    {
                        this.$cookies.set("csLogin", data.role.slug, "23h",'/mobile');
                        this.$cookies.set("date_format", data.user.employees[0].date_format, "23h", '/mobile');
                        this.$cookies.set("time_format", data.user.employees[0].time_format, "23h", '/mobile');
                        if(!this.app_source){
                          window.location.href = window.location.href.split('#')[0]+"mobile/";
                        }
                    } else{


                        this.$router.push({
                            path: "/switchClient",
                            query: query_params
                        });
                    }
                }

            } else if(data.role.slug == "employer-admin" || data.role.slug == "employer"){

                this.$router.push({
                    path: "/employerJobList"
                });

            } else if(data.role.slug == "super-admin") {
                this.$router.push({
                    path: "/clientList"
                });
            }
        }
        this.loading=false;
    },

    async domainIdentify() {
      this.loading=true;
      await service.get('auth/domain', {
          'url': document.location.href.split('#')[0] + "#/login",
      })
      .then((res) => {
          // console.log(res.data);
          this.domainLogo = (res.data.result)?res.data.result.logo:null;
          this.clientdata=(res.data.result)?res.data.result:null;
          this.login_image=this.clientdata?this.clientdata.login_image:"";
          var rawMsg = this.clientdata?this.clientdata.login_page_message:"";
          // #2036 — sanitize, do not decorate. This line used to be
          //   rawMsg.replace(/<a /g, '<a target="_blank" rel="noopener" ')
          // which ADDS an attribute and removes nothing, on a value rendered with v-html on
          // a page served to anyone who opens it. Every row written before #2036 is
          // unvalidated, so the display path — not the save path — is what disarms them.
          // target/rel are forced by the sanitizer's own hook now.
          // ⚠ `login_text` is assigned here and NEVER RENDERED — there is no v-html and no
          // {{ login_text }} in this template. Sanitized anyway, because the next person to
          // add one would re-open the hole silently, and one call costs nothing.
          this.login_text = sanitize(rawMsg);
          this.loginType=(this.clientdata.view_switch==1)?true:false;
          //console.log("Domain", this.clientdata);
          this.loading=false;

      }).catch((err) => {
          this.loading=false;
          this.$Progress.fail();
      });
    },

    async getEmployeeDetails() {
      this.$Progress.start();
      await service.get('employee/' + this.employee_id, {
          'Authorization': this.userToken,
          'cs3-context-role': this.userRole,
          'cs3-context-clientId': this.client_id
      })
      .then((res) => {
          this.profileData = res.data.result;
          this.paymentStatus = this.profileData.employable&&this.profileData.employable.stripe_subscription ? true : false;
          this.stripe_customer_id = this.profileData && this.profileData.employable && this.profileData.employable.stripe_customer_id ? this.profileData.employable.stripe_customer_id : null;
      }).catch((err) => {
          console.log(err);
      });
    },
  },
  async created() {
    localStorage.setItem('queryParams', null);
    this.app_source = this.$route.query.app_source ? this.$route.query.app_source : false;
    this.client_id = this.$route.query.client_id ? this.$route.query.client_id : '';
    this.calendar_subscription = this.$route.query.calendar_subscription ? this.$route.query.calendar_subscription : false;
    this.$store.dispatch('setQueryParamClientId', this.client_id);
    this.$store.dispatch('setQueryParamAppSource', this.app_source);
    const isMobile = this.deviceDetector;
    this.language = this.$route.query.lang ? this.$route.query.lang : 'en';
    this.languageSelected = this.language;
    localStorage.setItem('lang', this.languageSelected);
    this.$store.dispatch('saveBrowserSettingsLanguage', this.language);
    if(isMobile&&!this.app_source) {
      console.log("Mobile");
      let firstPath = window.location.href.split('#')[0];
      let secondPath = window.location.href.split('#')[1];
      window.location.href = firstPath + 'mobile/#' + secondPath;
    } else {
      console.log("Web");
      this.email = this.$route.query.email ? this.$route.query.email : null;
      this.token = this.$route.query.token ? this.$route.query.token : null;
      await this.domainIdentify();
      await this.loginUser();
    }
  },
  mounted() {},
  destroyed() {
    if(this.language == 'sp') {
      this.language = 'es';
    }
    this.languageSelected = this.language;
    this.$store.dispatch('saveBrowserSettingsLanguage', this.language);
    localStorage.setItem('lang', this.languageSelected);
    // location.reload();
  }

}
</script>

<style scoped>
.magic-link {
  margin: 15%;
  font-size: 16px;
  line-height: 2;
  font-weight: 400;
}
.magic-link .magic-link-user {
  color: #ff8800;
  font-weight: 400;
}
.magic-link .magic-link-message {
  color: #0b8300;
  font-weight: bold;
}
</style>
